// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-04-27
import React, { useMemo, useCallback } from 'react';
import { IconRemove, IconRemoveAudi } from 'src/content/icons';
import { THEME } from 'src/constants/ThemeNames';
import ScrollBar from 'src/components/ScrollBar/ScrollBar';
import { strings } from 'src/localization';
import css from './CalendarSelectAppt.module.scss';

interface IProps {
    title: string;
    information: string;
    onClose: (e: React.MouseEvent<SVGSVGElement> | React.KeyboardEvent<SVGSVGElement>) => void;
    theme?: string;
    colorSensitiveEnabled?: boolean;
}

/** Displays a transportation option's title and description in a scrollable info panel with a close button. */
const CalendarSelectApptInfo = (props: IProps) => {
    const { title, information, onClose, theme, colorSensitiveEnabled } = props;
    // Split information on newlines to reflect char returns in specs
    const informationDivs = useMemo(() => information.split('\n').map(
        (info, index) => <div key={index} className={css.infoDivs}>{info}</div>),
    [information]);
    // Audi only: bare X svg made keyboard-operable (role/tabIndex, Enter/Space); others match master.
    const closeKeyHandler = useCallback((e: React.KeyboardEvent<SVGSVGElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClose(e);
        }
    }, [onClose]);

    return (
        <div>
            {theme === THEME.AUDI ?
                <IconRemoveAudi
                    id={'CalendarSelectApptInfo-closeBtn'}
                    data-testid={'CalendarSelectApptInfo-closeBtn'}
                    onClick={onClose}
                    onKeyDown={closeKeyHandler}
                    role='button'
                    tabIndex={0}
                    aria-label={strings.Close}
                    className={css.removeIcon}
                /> :
                <IconRemove
                    id={'CalendarSelectApptInfo-closeBtn'}
                    data-testid={'CalendarSelectApptInfo-closeBtn'}
                    onClick={onClose}
                    className={css.removeIcon}
                    aria-label={strings.Close}
                />}
            <ScrollBar scrollHorizontal theme={theme} colorSensitiveEnabled={colorSensitiveEnabled}>
                <h2>{title}</h2>
                <div>
                    {informationDivs}
                </div>
            </ScrollBar>
        </div>
    );
};

export default CalendarSelectApptInfo;